<template>
    <div class="top">
        <div class="bg-white" style="padding: 10px 0 0 30px" v-if="+detailObj.orders.orderStatusSub === 1">
          <p style="color: #eb5757; font-size: 18px; font-weight: 600">{{ $t('Order.Details.Components.TopTimeLine.RefundFailed') }}</p>
          <p style="font-weight: 400; font-size: 14px; line-height: 21px; color: #000000">{{ detailObj.orders.auditReason }}</p>
        </div>
        <div class="f" v-if="showStatus === 'waiting_payment'">
          <div class="status bg-white f-c-c fd-c" v-cloak>
            <div>{{ $t('Order.Details.Components.TopTimeLine.WaitingPayment') }}</div>
            <div style="margin-top: 20px;width: 140px">
              <el-button type="primary" round @click="checkEmailBind">{{ $t('Order.Details.Components.TopTimeLine.PayNow') }}</el-button>
            </div>
          </div>
          <div class="process bg-white">
            <div class="explain" v-cloak>
              <template v-if="platformCode !== 'KA'">
                <span class="inline-block">{{ $t('Order.Details.Components.TopTimeLine.Tips1') }} </span>
              </template>
              <!-- 2024.4.23  琼瑜提的需求暂时去掉 -->
              <!-- <template v-if="countDownTime < 0">
                <i class="el-icon-time inline-block" style="margin-right: 4px"></i>
                <span class="inline-block" style="margin-right: 4px">{{ $t('orderDetail.Remaining') }}:</span>
                <span class="inline-block" style="color: red; margin-right: 4px">{{ countDownTime | getHHmmss }}</span>
                <span style="margin-right: 4px">{{ $t('Order.Details.Components.TopTimeLine.Tips1') }} </span>
              </template> -->
            </div>
            <el-timeline class="myTimeLine" v-cloak>
              <timeLineItem :timestamp="dayjs(detailObj.times.purchaseDate).format('YYYY-MM-DD HH:mm:ss')" color="#99C41C">{{ $t('Order.Details.Components.TopTimeLine.OrderSubmitted') }}</timeLineItem>
              <timeLineItem :timestamp="undefined">{{ $t('Order.Details.Components.TopTimeLine.OrderConfirmed') }}</timeLineItem>
              <timeLineItem :timestamp="undefined">{{ $t('Order.Details.Components.TopTimeLine.Shipped') }}</timeLineItem>
              <timeLineItem :timestamp="undefined">{{ $t('Order.Details.Components.TopTimeLine.OrderComplete') }}</timeLineItem>
            </el-timeline>
          </div>
        </div>
        <div class="f" v-if="showStatus === 'waiting_to_ship'">
          <div class="status bg-white f-c-c fd-c" v-cloak>
            <div>{{ $t('Order.Details.Components.TopTimeLine.WaitingToShip') }}</div>
          </div>
          <div class="process bg-white">
            <div class="explain" v-cloak>
              <span class="inline-block">{{ $t('Order.Details.Components.TopTimeLine.Tips2') }}</span>
            </div>
            <el-timeline class="myTimeLine" v-cloak>
              <timeLineItem :timestamp="dayjs(detailObj.times.purchaseDate).format('YYYY-MM-DD HH:mm:ss')" color="#99C41C">{{ $t('Order.Details.Components.TopTimeLine.OrderSubmitted') }}</timeLineItem>
              <timeLineItem :timestamp="dayjs(detailObj.times.payDate).format('YYYY-MM-DD HH:mm:ss')" color="#99C41C">{{ $t('Order.Details.Components.TopTimeLine.OrderConfirmed') }}</timeLineItem>
              <timeLineItem :timestamp="undefined">{{ $t('Order.Details.Components.TopTimeLine.Shipped') }}</timeLineItem>
              <timeLineItem :timestamp="undefined">{{ $t('Order.Details.Components.TopTimeLine.OrderComplete') }}</timeLineItem>
            </el-timeline>
          </div>
        </div>
        <div class="f" v-if="showStatus === 'partial_shipped'">
          <div class="status bg-white f-c-c" v-cloak>
            <div>{{ $t('Order.Details.Components.TopTimeLine.PartialShipped') }}</div>
          </div>
          <div class="process bg-white">
            <div class="explain" v-cloak>
              <span class="inline-block">{{ $t('Order.Details.Components.TopTimeLine.Tips3') }}</span>
            </div>
            <el-timeline class="myTimeLine" v-cloak>
              <timeLineItem :timestamp="dayjs(detailObj.times.purchaseDate).format('YYYY-MM-DD HH:mm:ss')" color="#99C41C">{{ $t('Order.Details.Components.TopTimeLine.OrderSubmitted') }}</timeLineItem>
              <timeLineItem :timestamp="dayjs(detailObj.times.payDate).format('YYYY-MM-DD HH:mm:ss')" color="#99C41C">{{ $t('Order.Details.Components.TopTimeLine.OrderConfirmed') }}</timeLineItem>
              <timeLineItem :timestamp="dayjs(detailObj.times.deliveryDate).format('YYYY-MM-DD HH:mm:ss')" color="#99C41C">{{ $t('Order.Details.Components.TopTimeLine.Shipped') }}</timeLineItem>
              <timeLineItem :timestamp="undefined">{{ $t('Order.Details.Components.TopTimeLine.OrderComplete') }}</timeLineItem>
            </el-timeline>
          </div>
        </div>
        <div class="f" v-if="showStatus === 'fully_shipped'">
          <div class="status bg-white f-c-c" v-cloak>
            <div>{{ $t('Order.Details.Components.TopTimeLine.FullyShipped') }}</div>
          </div>
          <div class="process bg-white">
            <div class="explain" v-cloak>
              <span class="inline-block">{{ $t('Order.Details.Components.TopTimeLine.Tips4') }}</span>
            </div>
            <el-timeline class="myTimeLine" v-cloak>
              <timeLineItem :timestamp="dayjs(detailObj.times.purchaseDate).format('YYYY-MM-DD HH:mm:ss')" color="#99C41C">{{ $t('Order.Details.Components.TopTimeLine.OrderSubmitted') }}</timeLineItem>
              <timeLineItem :timestamp="dayjs(detailObj.times.payDate).format('YYYY-MM-DD HH:mm:ss')" color="#99C41C">{{ $t('Order.Details.Components.TopTimeLine.OrderConfirmed') }}</timeLineItem>
              <timeLineItem :timestamp="dayjs(detailObj.times.deliveryDate).format('YYYY-MM-DD HH:mm:ss')" color="#99C41C">{{ $t('Order.Details.Components.TopTimeLine.Shipped') }}</timeLineItem>
              <timeLineItem :timestamp="undefined">{{ $t('Order.Details.Components.TopTimeLine.OrderComplete') }}</timeLineItem>
            </el-timeline>
          </div>
        </div>
        <div class="f" v-if="showStatus === 'completed'">
          <div class="status bg-white f-c-c" v-cloak>
            <div>{{ $t('Order.Details.Components.TopTimeLine.Completed') }}</div>
          </div>
          <div class="process bg-white">
            <div class="explain" v-cloak>
              <span class="inline-block">{{ $t('Order.Details.Components.TopTimeLine.Tips5') }}</span>
            </div>
            <el-timeline class="myTimeLine" v-cloak>
              <timeLineItem :timestamp="dayjs(detailObj.times.purchaseDate).format('YYYY-MM-DD HH:mm:ss')" color="#99C41C">{{ $t('Order.Details.Components.TopTimeLine.OrderSubmitted') }}</timeLineItem>
              <timeLineItem :timestamp="dayjs(detailObj.times.payDate).format('YYYY-MM-DD HH:mm:ss')" color="#99C41C">{{ $t('Order.Details.Components.TopTimeLine.OrderConfirmed') }}</timeLineItem>
              <timeLineItem :timestamp="dayjs(detailObj.times.deliveryDate).format('YYYY-MM-DD HH:mm:ss')" color="#99C41C">{{ $t('Order.Details.Components.TopTimeLine.Shipping') }}</timeLineItem>
              <timeLineItem :timestamp="dayjs(detailObj.times.completedDate).format('YYYY-MM-DD HH:mm:ss')" color="#99C41C">{{ $t('Order.Details.Components.TopTimeLine.OrderComplete') }}</timeLineItem>
            </el-timeline>
          </div>
        </div>
        <div class="f" v-if="showStatus === 'cancel'">
          <div class="status bg-white f-c-c" v-cloak>
            <div>{{ $t('Order.Details.Components.TopTimeLine.Cancel') }}</div>
          </div>
          <div class="process bg-white">
            <div class="explain" v-cloak>
              <span class="inline-block">{{ $t('Order.Details.Components.TopTimeLine.Tips6') }}</span>
            </div>
            <el-timeline class="myTimeLine" v-cloak>
              <timeLineItem :timestamp="dayjs(detailObj.times.purchaseDate).format('YYYY-MM-DD HH:mm:ss')" color="#99C41C">{{ $t('Order.Details.Components.TopTimeLine.OrderSubmitted') }}</timeLineItem>
              <timeLineItem :timestamp="dayjs(detailObj.times.cancelDate).format('YYYY-MM-DD HH:mm:ss')" color="#99C41C">{{ $t('Order.Details.Components.TopTimeLine.Cancel') }}</timeLineItem>
              <timeLineItem :timestamp="undefined" color="#99C41C">{{ $t('Order.Details.Components.TopTimeLine.Finish') }}</timeLineItem>
            </el-timeline>
          </div>
        </div>
        <div class="f" v-if="detailObj.orders.status === 'abnormal_order'">
          <div class="status bg-white f-c-c fd-c" v-cloak>
            <div>{{ $t('Order.Details.Components.TopTimeLine.AbnormalOrder') }}</div>
            <div v-if="detailObj.orders.notes" style="margin-top: 20px;">
              <el-button v-if="detailObj.orders.notes && detailObj.orders.notes.code === 1" type="danger" round @click="$emit('updateAddress')">{{ $t('Order.Details.Index.CompleteInformation') }}</el-button>
              <el-button v-else-if="detailObj.orders.notes && detailObj.orders.notes.code && [2,3].includes(detailObj.orders.notes.code)" round type="primary" @click="checkEmailBind">{{ $t('Order.Details.Components.TopTimeLine.GetLogistics') }}</el-button>
              <!-- <el-button v-else type="danger" round @click="$emit('updateAddress')">{{ $t('Order.Details.Index.CompleteInformation') }}</el-button> -->
            </div>
          </div>
          <div class="process bg-white">
            <div class="explain" v-if="detailObj.orders.notes">
              <h4 class="inline-block" v-if="detailObj.orders.notes.code === 1">{{ $t('Order.Details.Components.TopTimeLine.Tips7') }}</h4>
              <h4 class="inline-block" v-if="[2,3].includes(detailObj.orders.notes.code)">{{ $t('Order.Details.Components.TopTimeLine.Tips8') }}</h4>
            </div>
            <div v-if="detailObj.orders.notes">{{ detailObj.orders.notes.value }}</div>
          </div>
        </div>
        <payDialog ref="payDialog" @closeDialog="closeDialog"></payDialog>
        <!-- 设置账号 -->
        <AccountSetting ref="accountSetting" @setSuccess="setSuccess"></AccountSetting>
      </div>
</template>

<script>
import timeLineItem from '@/components/common/timeLineItem'
import dayjs from 'dayjs'
import payDialog from '../../list/components/payDialog.vue'
import AccountSetting from '@/views/personal-center/account-setting/components/AccountSetting.vue'
export default {
  props: {
    detailObj: {
      type: Object,
      default: () => ({
        'times': {
          'purchaseDate': 1670320180000,
          'payDate': 1670320200000,
          'completedDate': 2021,
          'cancelDate': 1,
          'refundDate': 1,
          'deliveryDate': 1670720180000
        },
        'address': {
          'country': 'CH',
          'city': '深圳',
          'phone': '137562586632',
          'recipient': '铁头男孩',
          'street1': '街道一',
          'street2': '街道二',
          'province': '湖南省',
          'zip': '邮编',
          'vat': 'ssssaca',
          'ioss': ''
        },
        'orders': {
          'storeOrderId': 'xdczxczxc',
          'kkOrderId': 'xzczxczxcvzxnkNx',
          'platformCode': 'AM',
          'remark': '我不要这个订单的',
          'refundStatus': 'XSS',
          'fulfillmentStatus': 'fully_shipped',
          'financialStatus': 'waiting',
          'channelCode': '',
          'platformName': '',
          'storeName': '',
          'email': '',
          'refundReason': '',
          'status': 'cancel'
        },
        'pays': {
          'finalAmount': 100,
          'freightAmount': 1000,
          'skusAmount': 10000,
          'paymentMethod': 'paypay',
          'couponAmount': 1,
          'paymentId': '',
          'discountAmount': ''
        },
        'orderLogistics': [
          {
            'omsPackId': '',
            'deliveryDate': 137562586632,
            'trackingCode': '1ssdvsdv',
            'packStatus': 'Preparing',
            'logisticsProviders': '小四快递',
            'weightSum': '',
            'items': [
              {
                'refundStatus': 'XSS',
                'fulfillmentStatus': 'fulfillmentStatusName',
                'financialStatus': '',
                'imageUrl': 'LKNASKONCOASNCLKNAS',
                'productName': 'NC 女士缎面真丝睡衣..',
                'productNum': 2,
                'skuCode': 'AMB00393',
                'sellerSku': 'AMB00393',
                'options': 'red',
                'price': 50,
                'finalAmount': 1,
                'isOutOfStock': 1,
                'subtotal': ''
              }
            ]
          }
        ]
      })
    }
  },
  components: {
    timeLineItem,
    payDialog,
    AccountSetting
  },
  filters: {
    getHHmmss(value) {
      let day = Math.floor(value / (1000 * 60 * 60 * 24))
      let hours = Math.floor((value / (1000 * 60 * 60)) % 24).toString()
      let minute = Math.floor((value / (1000 * 60)) % 60).toString()
      let second = Math.floor((value / 1000) % 60).toString()
      if (hours.length === 1) hours = `0${hours}`
      if (minute.length === 1) minute = `0${minute}`
      if (second.length === 1) second = `0${second}`
      if (day > 0) {
        return `${day} days ${hours}:${minute}:${second}`
      }
      return `${hours}:${minute}:${second}`
    }
  },
  computed: {
    showStatus() {
      if (['waiting_payment', 'completed', 'cancel'].includes(this.detailObj.orders.status)) return this.detailObj.orders.status
      if (this.detailObj.orders.status === 'abnormal_order') return this.detailObj.orders.financialStatus
      if (this.detailObj.orders.status === 'processing') return this.detailObj.orders.fulfillmentStatus
      return 'NULL'
      /*
        waiting_payment 待支付
        completed 已完成
        cancel 已取消
        waiting_to_ship 待发货
        fully_shipped 已发货
        partial_shipped  部分发货
      */
    },
    platformCode() {
      if (this.detailObj.orders.platformCode) return this.detailObj.orders.platformCode
      return 'KA'
    },
    countDownTime() {
      let startTime = this.detailObj.times.purchaseDate
      let endTime = startTime + 1000 * 60 * 60 * 24 * 5
      return endTime - this.currentTime - 3000
    }
  },
  data() {
    return {
      remainingTime: 1670320080000, // 下单时间，做倒计时
      Interval: null,
      currentTime: dayjs().valueOf(),
      dayjs
    }
  },
  mounted() {
    if (this.showStatus === 'waiting_payment') {
      const that = this
      this.Interval = setInterval(() => {
        that.currentTime = new Date().valueOf()
        if (that.currentTime < 0) {
          that.detailObj.orders.status = 'cancel'
          clearInterval(that.Interval)
        }
      }, 1000)
    }
  },
  methods: {
    checkEmailBind() {
      if (!this.$store.state.common.email) {
        this.$refs.accountSetting.show('bindEmail')
      } else {
        this.payNowClick()
      }
    },
    setSuccess() {
      this.payNowClick()
    },
    payNowClick() {
      const { productName, productNum, skuCode: productSku } = this.detailObj.orderLogistics[0].items[0]
      const product = {
        kkOrderIds: [this.detailObj.orders.kkOrderId],
        storeGroup: this.detailObj.orders.storeGroup,
        totalAmount: this.detailObj.pays.finalAmount,
        platformCode: this.detailObj.orders.platformCode,
        productName,
        productNum,
        productSku,
        orderItems: this.detailObj.orderLogistics[0].items,
        customer: this.detailObj.address.recipient,
        status: this.showStatus,
        ext: JSON.stringify(this.$route.query),
        // productName: this.detailObj.orders.productName,
        // productNum:
        orderType: this.detailObj.orders.orderType
      }
      localStorage.setItem('product.kkOrderId', this.detailObj.orders.kkOrderId)
      if (this.isPC) {
        this.$refs.payDialog.show(product)
      } else {
        this.$refs.payDialog.MTShow(product)
      }
    },

    closeDialog() {
      this.$emit('updateDetail')
    }

  }
}
</script>

<style lang="scss" scoped>
.top {
    margin-bottom: 14px;
    .status {
      height: 146px;
      margin-right: 2px;
      // padding-left: 30px;
      width: 300px;
      > div:first-of-type {
        font-size: 18px;
        font-weight: bold;
      }
    }
    .process {
      height: 146px;
      flex: 1;
      padding: 20px 0 20px 40px;
      .myTimeLine {
        display: flex;
      }
      .explain {
        height: 24px;
        line-height: 24px;
        font-size: 14px;
        margin-bottom: 24px;
      }
    }
  }
</style>
